/**
 * Ensures that a rating is within the range of 0 to 5.
 * @param rating {number} The rating to be validated.
 */
export default function safeRating(rating: number): number {
  return Math.max(0, Math.min(5, Number(rating)));
}
